import { useSites, useAnalytics } from '../api/hooks';
import { ErrorState, Empty, Loading } from '../components/States';
import { inr, num } from '../components/money';

export default function Sites() {
  const { data, isPending, error, refetch } = useSites();
  const { data: a } = useAnalytics(30, null);

  if (isPending) return <Loading what="your sites" />;
  if (error) return <ErrorState error={error} onRetry={() => refetch()} />;
  if (!data?.length) return <Empty title="No sites yet">Sites are created in the Android app.</Empty>;

  const cmp = new Map((a?.site_comparison ?? []).map((s) => [s.site_name, s]));

  return (
    <>
      <div className="section__head">
        <h1 className="section__title">Sites</h1>
        <p className="section__sub muted">{data.length} site{data.length === 1 ? '' : 's'}</p>
      </div>
      <div className="card scroll-x" style={{ padding: 0 }}>
        <table>
          <thead>
            <tr>
              <th>Site</th><th>Location</th><th>Materials</th>
              <th>Low</th><th>Out</th><th>Stock value</th><th>Consumed (30d)</th><th>Pending</th>
            </tr>
          </thead>
          <tbody>
            {data.map((s) => {
              const c = cmp.get(s.name);
              return (
                <tr key={s._id}>
                  <td><strong>{s.name}</strong></td>
                  <td className="muted">{s.location || '—'}</td>
                  <td className="mono-num">{num(c?.total_materials ?? s.material_count ?? null)}</td>
                  <td className="mono-num">
                    {c && c.low_stock_count > 0
                      ? <span className="pill pill--warn">{c.low_stock_count}</span>
                      : <span className="muted">0</span>}
                  </td>
                  <td className="mono-num">
                    {c && c.out_of_stock_count > 0
                      ? <span className="pill pill--bad">{c.out_of_stock_count}</span>
                      : <span className="muted">0</span>}
                  </td>
                  <td className="mono-num">{inr(s.stock_value ?? null)}</td>
                  <td className="mono-num">{inr(c?.value_consumed ?? null)}</td>
                  <td className="mono-num">{num(c?.pending_slips ?? 0)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
